import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import { IAsset } from '@models';
import {
    GRID_SERVICE,
    ODataGridComponent,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import {
    AssetService,
    ModalService,
} from '@services';

import {
    BehaviorSubject,
    Observable,
    of,
} from 'rxjs';
import {
    filter,
    finalize,
    switchMap,
} from 'rxjs/operators';

import { AssetModalComponent } from './modals';

@Component({
    templateUrl: './assets.page.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: AssetService,
    }, {
        provide: STATE_HANDLER,
        useValue: urlStateHandler,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetsPageComponent extends ODataGridComponent<IAsset, number> {

    public loadingModal$ = new BehaviorSubject(false);

    private _modalService = this._injector.get<ModalService>(ModalService);

    public openModal(model?: IAsset) {
        this.loadingModal$.next(true);

        const clone$: Observable<IAsset | undefined> = !!model ?
            (this._service as AssetService).getInstance(model.id, ['RobotValues']) :
            of(undefined);

        clone$.pipe(
            switchMap(clone => this._modalService
                .openModal(AssetModalComponent, clone, { autoFocus: false })
                .afterClosedResult()),
            filter((result) => !!result),
            finalize(() => this.loadingModal$.next(false)),
        )
        .subscribe(() => this._refresh$.next());
    }

    public get allowDelete(): boolean {
        return this._grid.selectionManager.hasValue() &&
            this._grid.selectionManager.selected.every(asset => asset.canBeDeleted);
    }
}
